// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getFirestore } from "firebase/firestore";
import { enableIndexedDbPersistence } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; 
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBLOYm2FZrZMagpqocoLL8fQPlvIu-hflU",
  authDomain: "leatherhood-c0424.firebaseapp.com",
  projectId: "leatherhood-c0424",
  storageBucket: "leatherhood-c0424.firebasestorage.app",
  messagingSenderId: "113881685261",
  appId: "1:113881685261:web:6ae9cfe227321610f36444",
  measurementId: "G-YX8Y5VG4VQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
// Initialize services you will use
export const db = getFirestore(app);

export const auth = getAuth(app);
export const storage = getStorage(app); 
enableIndexedDbPersistence(db).catch(console.error);

export default app;